import { generateMedia } from 'styled-media-query';

const mediaqueries = generateMedia({
  desktopBig: '1700px',
  desktop: '1280px',
  lessDesktop: '1279px',
  greatherDesktop: '1281px',
  greatherTabletLandScape: '1180px',
  lessGreatherTabletLandScape: '1080px',
  tabletLandscape: '1024px',
  greatherTablet: '800px',
  tablet: '721px',
  mobile: '720px',
  lessMobile: '460px'
});

export default mediaqueries;
